import axios from "axios"

export const client = axios.create()

client.defaults.headers = {
  "X-Requested-With": "XMLHttpRequest",
}
